import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import { CircularProgress, Stack, Typography } from '@mui/material';

const TestWebhookSteps = ({ label, completed, failed, loading }) => {
  let icon;

  if (failed) {
    icon = <CancelIcon sx={{ color: '#ef4444' }} />;
  } else if (completed) {
    icon = <CheckCircleIcon sx={{ color: '#22c55e' }} />;
  } else if (loading) {
    icon = <CircularProgress size={18} />;
  } else {
    icon = <RadioButtonUncheckedIcon sx={{ color: '#6b7280' }} />;
  }

  return (
    <Stack direction="row" spacing={2} alignItems="center">
      {icon}
      <Typography>{label}</Typography>
    </Stack>
  );
};

export default TestWebhookSteps;
